export default __webpack_public_path__ + "static/media/ventaNoPermitida.c2d1e325.svg";